/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateAgencyDto } from '../models/CreateAgencyDto';
import type { CreateCompanyDto } from '../models/CreateCompanyDto';
import type { DeleteAgencyEntity } from '../models/DeleteAgencyEntity';
import type { DeleteCompanyEntity } from '../models/DeleteCompanyEntity';
import type { DetailAgencyEntity } from '../models/DetailAgencyEntity';
import type { DetailCompanyEntity } from '../models/DetailCompanyEntity';
import type { GetListAgency } from '../models/GetListAgency';
import type { GetListCompanyEntity } from '../models/GetListCompanyEntity';
import type { GetListCompanyPagination } from '../models/GetListCompanyPagination';
import type { UpdateAgencyDto } from '../models/UpdateAgencyDto';
import type { UpdateCompanyDto } from '../models/UpdateCompanyDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserWalletCompanyInfoService {
  /**
   * @returns GetListCompanyEntity
   * @throws ApiError
   */
  public static companyControllerFindAll(): CancelablePromise<GetListCompanyEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/companies-all',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param page Page number (default: 1)
   * @param limit Number of items per page (default: 10)
   * @param search Search by company name (case-insensitive)
   * @param companyId Filter by company ID; Merchant and Agency are restricted to their own Company
   * @returns GetListCompanyPagination
   * @throws ApiError
   */
  public static companyControllerFindCompanies(
    page?: number,
    limit?: number,
    search?: string,
    companyId?: string,
  ): CancelablePromise<GetListCompanyPagination> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/companies',
      query: {
        page: page,
        limit: limit,
        search: search,
        companyId: companyId,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns DetailCompanyEntity
   * @throws ApiError
   */
  public static companyControllerCreateComp(
    requestBody: CreateCompanyDto,
  ): CancelablePromise<DetailCompanyEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/companies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns DetailCompanyEntity
   * @throws ApiError
   */
  public static companyControllerUpdateComp(
    id: string,
    requestBody: UpdateCompanyDto,
  ): CancelablePromise<DetailCompanyEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/user-wallet/companies/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @returns DetailCompanyEntity
   * @throws ApiError
   */
  public static companyControllerGetComp(
    id: string,
  ): CancelablePromise<DetailCompanyEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/companies/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @returns DeleteCompanyEntity
   * @throws ApiError
   */
  public static companyControllerDeleteComp(
    id: string,
  ): CancelablePromise<DeleteCompanyEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/user-wallet/companies/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param companyId
   * @param page Page number (default: 1)
   * @param limit Number of items per page (default: 10)
   * @returns GetListAgency
   * @throws ApiError
   */
  public static companyControllerAgencyFindAll(
    companyId?: string,
    page?: number,
    limit?: number,
  ): CancelablePromise<GetListAgency> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/agencies',
      query: {
        companyId: companyId,
        page: page,
        limit: limit,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param requestBody
   * @returns DetailAgencyEntity
   * @throws ApiError
   */
  public static companyControllerCreateAgency(
    requestBody: CreateAgencyDto,
  ): CancelablePromise<DetailAgencyEntity> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/v1/user-wallet/agencies',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns DetailCompanyEntity
   * @throws ApiError
   */
  public static companyControllerUpdateAgency(
    id: string,
    requestBody: UpdateAgencyDto,
  ): CancelablePromise<DetailCompanyEntity> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/v1/user-wallet/agencies/{id}',
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @returns DetailCompanyEntity
   * @throws ApiError
   */
  public static companyControllerGetAgency(
    id: string,
  ): CancelablePromise<DetailCompanyEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/user-wallet/agencies/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }

  /**
   * @param id
   * @returns DeleteAgencyEntity
   * @throws ApiError
   */
  public static companyControllerDeleteAgency(
    id: string,
  ): CancelablePromise<DeleteAgencyEntity> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/v1/user-wallet/agencies/{id}',
      path: {
        id: id,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forrbidden`,
      },
    });
  }
}
